import { jsxs as s, jsx as l } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import { formatDate as b } from "../../../utils/format-date.js";
import { ContextMenu as v } from "../context-menu/index.js";
const g = (o) => {
  const {
    isNew: c,
    isEnded: m,
    Image: r,
    description: d,
    timestamp: n,
    title: N,
    button: a,
    items: i,
    showAllMobile: h,
    onClick: t,
    rowClassName: u,
    language: p
  } = o;
  return /* @__PURE__ */ s(
    "div",
    {
      className: `${e.container} ${h ? "" : e.hideMobile} ${m ? e.ended : ""} ${t ? e.clickable : ""} ${u ?? ""}`,
      onClick: t ?? (() => {
      }),
      children: [
        c && /* @__PURE__ */ l("div", { className: e.newDot }),
        r,
        /* @__PURE__ */ s("div", { className: e.detailsContainer, children: [
          /* @__PURE__ */ l("div", { className: e.lawyerName, children: N }),
          /* @__PURE__ */ l("div", { className: e.prematterName, children: d })
        ] }),
        n && /* @__PURE__ */ l("div", { className: e.timestamp, children: b(n, p) }),
        a ? /* @__PURE__ */ s(
          "button",
          {
            onClick: a.onClick,
            className: `${e.rowButton} ${a.className ?? ""}`,
            children: [
              /* @__PURE__ */ l("div", { className: e.buttonLabel, children: a.label }),
              a.icon
            ]
          }
        ) : null,
        i != null && i.length ? /* @__PURE__ */ l(v, { className: e.menuIcon, items: i }) : null
      ]
    }
  );
};
export {
  g as MessageRow
};
